import { render, staticRenderFns } from "./HousePinList.vue?vue&type=template&id=18b61322&"
import script from "./HousePinList.vue?vue&type=script&lang=js&"
export * from "./HousePinList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports